import { ReactNode } from "react";
import { useTranslation } from "next-i18next";
import {
    ArrowLeftIcon,
    QuestionMarkCircleIcon,
} from "@heroicons/react/24/outline";
import { useRouter } from "next/router";
function CheckIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className="w-[1.5em] h-[1.5em] text-[#68D585]"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4.5 12.75l6 6 9-13.5"
            />
        </svg>
    );
}

const PricingCardComponent: React.FC<{
    className: string;
    transIndex: string;
}> = ({ className, transIndex }) => {
    const { t } = useTranslation("common");
    const router = useRouter();
    return (
        <div
            className={
                "w-full h-[85em] 2xl:h-[95em] flex flex-col p-[5em]  text-[0.4rems] md:text-[0.6rem] shadow-lg border-primary border-[0.2em]" +
                " " +
                className
            }
        >
            <div className="h-[75%]">
                <div
                    color="transparent"
                    className="m-0 mb-8 text-[1em] text-center"
                >
                    <div className="quota font-bold text-[black] text-right mb-[2em] text-[2.5em]">
                        {t(`home.pricing.${transIndex}.starter`)}
                    </div>
                    <div className="mt-2 flex justify-start gap-1 text-[6em] font-bold">
                        {t(`home.pricing.${transIndex}.price`)}
                        <span className="mt-2 self-end  text-[0.5em]">
                            {t(`home.pricing.${transIndex}.currency`)}
                        </span>
                        <span className="self-end text-[0.5em] font-normal">
                            {t(`home.pricing.${transIndex}.perMonth`)}
                        </span>
                    </div>
                </div>
                <div className="p-0 text-[2em] ">
                    <ul className="flex flex-col gap-[1.5em] md:gap-[2em]">
                        <li className="flex items-center gap-[1.5em] text-[1em]">
                            <CheckIcon />

                            <div className="font-normal text-[1em] ">
                                {t(`home.pricing.${transIndex}.features.f1`)}
                            </div>
                        </li>
                        <li className="flex items-center gap-[1.5em]">
                            <CheckIcon />

                            <div className="font-normal">
                                {t(`home.pricing.${transIndex}.features.f2`)}
                            </div>
                        </li>
                        <li className="flex items-center gap-[1.5em]">
                            <CheckIcon />

                            <div className="font-normal">
                                {t(`home.pricing.${transIndex}.features.f3`)}
                            </div>
                        </li>
                        <li className="flex items-center gap-[1.5em]">
                            <CheckIcon />

                            <div className="font-normal">
                                {t(`home.pricing.${transIndex}.features.f4`)}
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="p-0  mt-auto">
                <button
                    color="white"
                    onClick={() => router.push("/sign")}
                    className="hover:scale-[1.02] w-[90%] bg-transparent text-secondary normal-case h-[9em] rounded-[1em] transition-all duration-500 focus:scale-[1.02] active:scale-100 flex justify-between items-center px-[4em] text-[1em] font-bold"
                >
                    <p className="text-[2em] ">
                        {t(`home.pricing.${transIndex}.buyNow`)}{" "}
                    </p>
                    <ArrowLeftIcon className="w-[3em]" />
                </button>
                <div className="hidden text-[2.5em] mt-[1em]  items-center gap-[0.3em]">
                    <QuestionMarkCircleIcon className="w-[1.5em]" />
                    <p>المزيد من التفاصيل</p>
                </div>
            </div>
        </div>
    );
};

export default PricingCardComponent;
